(function() {
  'use strict';

  angular
    .module('chrisbousteadCom', ['ngAnimate', 'ngTouch', 'ngSanitize', 'ui.router']);

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .directive('windowHeight', ['$window',windowHeight]);

  /** @ngInject */
  function windowHeight($window) {

    return {
      restrict: 'A',
      link: function ($scope, $element, $attrs){

        var setWindowHeight = function($el, height){
          $el.css('height',height+'px');
        };

        setWindowHeight($element, $window.innerHeight);

        angular.element($window).bind('resize',function(){
          setWindowHeight($element,$window.innerHeight)
        })

      }
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .factory('$ratchet', ['$window',ratchet]);

  /** @ngInject */
  function ratchet($window) {

    var ws = new WebSocket('ws://localhost:8080/chat');

    return ws;

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .directive('pageLoader', pageLoader);

  /** @ngInject */
  function pageLoader($timeout) {

    return {
      restrict: 'E',
      templateUrl: 'app/components/page-loader/page-loader.html',
      link: function ($scope, $element, $attrs){

        $scope.loaderVisible = true;

        window.onload = function(){
          $scope.loaderVisible = false;
        };

        $timeout(function(){
          $scope.loaderVisible = false;
        },1500);

      }
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .directive('niceLoad', niceLoad);

  /** @ngInject */
  function niceLoad($aboutphoto) {

    return {
      restrict: 'A',
      scope : {
        niceLoad : '@'
      },
      link: function ($scope, $element, $attrs){

        //$element.addClass('niceUnLoaded');

        var showEl = TweenMax.from($element,.5, {opacity: 0, paused: true});

        var img = new Image();
        img.onload = function(e){
          showEl.play();
          //$element.removeClass('niceUnLoaded');
        };
        img.src = $scope.niceLoad;


      }
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .directive('cdbNavbar', cdbNavbar);

  /** @ngInject */
  function cdbNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html'
    };

    return directive;

    /** @ngInject */
    function NavbarController() {

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .directive('matchHeight', ['$window',matchHeight]);

  /** @ngInject */
  function matchHeight($window) {

    return {
      restrict: 'A',
      link: function ($scope, $element, $attrs){

        var elToMatch = $attrs.matchHeight;

        if(!elToMatch) return;

        var $elToMatch = document.querySelector(elToMatch);

        if(!$elToMatch) return;

        var getElHeight = function($el){
          return $el.offsetHeight;
        };

        // Set the height right away
        $element.css('height', getElHeight($elToMatch) + 'px');

        var $win = angular.element($window);

        $win.bind('resize',function(){
          $element.css('height', getElHeight($elToMatch) + 'px');
        })

      }
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .factory('$lightbox', lightbox);

  /** @ngInject */
  function lightbox($rootScope) {

    return {

      content : null,
      caption : null,

      show : function(content, caption){
        this.content = content;
        this.caption = caption;
        $rootScope.lightboxVisible = true;
      },

      hide : function(){
        $rootScope.lightboxVisible = false;
      }

    };

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .directive('lightbox', lightbox);

  /** @ngInject */
  function lightbox($lightbox) {

    return {
      restrict: 'E',
      templateUrl: 'app/components/lightbox/lightbox.html',
      link: function ($scope, $element, $attrs){

        $scope.hide = $lightbox.hide;
        $scope.lbContentLoaded = false;

        var $img = angular.element($element.find('image'));

        //console.log($img);
        //
        //$img.on('load',function(){
        //  var nat_width = this.naturalWidth;
        //  if(nat_width) setWidth(nat_width);
        //  $scope.$apply(function(){
        //    $scope.lbContentLoaded = true;
        //  });
        //  console.log('loaded');
        //});

        function setWidth(width){
          if(width > window.innerWidth)
            $img.css('width',window.innerWidth+'px');
        }

        console.log()

      }
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .directive('instantConvo', ['$ratchet',instantConvo]);

  /** @ngInject */
  function instantConvo($ratchet) {

    return {
      restrict: 'E',
      templateUrl: 'app/components/instant-convo/instant-convo.html',
      link: function ($scope, $element, $attrs){

        $scope.messageModel = {};
        $scope.log = [];

        $ratchet.onopen = function(){
          console.log('open');
        };
        $ratchet.onmessage = function(event){

          var data = JSON.parse(event.data);

          console.log(data);

          if(data.from != 'user')
            $scope.log.push(data);


        };


        $scope.sendMessage = function(message){

          if (!message) return;

          // Record in the log...
          $scope.log.push({
            time : Date.now(),
            msg : message,
            from : 'You'
          });

          // Send the message...
          $ratchet.send(JSON.stringify({
            from: 'user',
            msg: message
          }));

          // Clear the input...
          $scope.messageModel.content = '';

        };



      }
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .factory('$aboutphoto',function($rootScope){
      return {
        setImage : function(img){
          $rootScope.aboutBg = {
            backgroundImage : 'url("'+img.src+'")'
          };
          $rootScope.aboutBgActive = true;
          $rootScope.$apply();
        },
        clearImage : function(){
          //$rootScope.aboutBg = {};
          $rootScope.aboutBgActive = false;
          $rootScope.$apply();
        }
      }
    })
    .directive('aboutPhoto', aboutPhoto);

  /** @ngInject */
  function aboutPhoto($aboutphoto) {

    return {
      restrict: 'A',
      scope : {
        aboutPhoto : '@'
      },
      link: function ($scope, $element, $attrs){

        var img = new Image();
        img.onload = function(e){
          $element.addClass('loaded');
        };
        img.src = $scope.aboutPhoto;


        var isTouchDevice = function() {
          return 'ontouchstart' in window
            || navigator.maxTouchPoints;
        };

        if(!isTouchDevice()) {
          $element.bind('mouseenter', function () {
            $aboutphoto.setImage(img);
          });


          $element.bind('mouseleave', function () {
            $aboutphoto.clearImage();
          });
        }else {

          $element.bind('touchstart', function () {
            console.log('touchstart');
            $aboutphoto.setImage(img);
          });


          $element.bind('touchend touchcancel', function () {
            console.log('touchend');
            $aboutphoto.clearImage();
          });
        }

      }
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .directive('cmykCanvas', ['$window',cmykCanvas]);

  /** @ngInject */
  function cmykCanvas($window) {

    var words = [
      'chris',
      'energetic',
      'developer',
      'engineer',
      'driven',
      'more'
    ];

    var directive = {
      restrict: 'E',
      template: '<canvas id="cmykCanvas"></canvas>',
      replace : true,
      link: function ($scope, $element, $attrs){

        var currentFrame, lastFrame, frameDuration, lastUpdate, trans_x, trans_y;
        var speed = 100;
        var instances = 3;
        var currentWord = 0;
        var getWordsEls = function(){ return angular.element($element[0].querySelectorAll('.words')) };
        var $words_els = getWordsEls();
        var movementFactor = 2;

        var initCanvas = function(){
          $element.attr('width',$element[0].offsetWidth);
          $element.attr('height',$element[0].offsetHeight);
        }();

        var clearCanvas = function(){
          $element[0]
            .getContext('2d')
            .clearRect(0, 0, $element[0].width, $element[0].height);
        };

        var writeWord = function(word){
          var ctx = $element[0].getContext('2d');
          //ctx.font = "48px Cutive Mono";
          ctx.font = "48px serif";
          //console.log(trans_x, trans_y);
          var x = trans_x || 0;
          var y = trans_y || $element[0].height/2;
          console.log(y, y + window.innerHeight / 2);
          //y = y + window.innerHeight / 2;
          //console.log(x,y);
          ctx.globalCompositeOperation = 'multiply';
          ctx.fillStyle = 'rgb(255,0,255)';
          ctx.fillText(word, x, y);
          ctx.fillStyle = 'rgb(0,255,255)';
          ctx.fillText(word, x + (x *.1), y + (y *.1));
          ctx.fillStyle = 'rgb(255,255,0)';
          ctx.fillText(word, x + (x *.2), y + (y *.2));
        };


        //for (var i = 0; i < words.length; ++i){
        //  $words_els.append('<span class="word">'+words[i]+'</span>');
        //}

        //for (var i = 0; i < instances-1; ++i){
        //  var clone = $words_els.clone()
        //  $element.append(clone);
        //}

        //$words_els = getWordsEls();
        //$words_els.addClass('active-'+currentWord);
        //
        //function removeClassByPrefix(els) {
        //  angular.forEach(els, function(el){
        //    el.className = el.className.replace(/(^|\s)active-\S+/g, '');
        //  })
        //  return els;
        //}

        function loopAni(timestamp){
          currentFrame = timestamp;
          frameDuration = currentFrame - lastFrame;

          if(!lastUpdate || currentFrame - lastUpdate > speed) {

            if(currentWord == words.length - 1){
              currentWord = 0;
            }else{
              currentWord += 1;
            }

            clearCanvas();

            writeWord(words[currentWord]);

            //$words_els.addClass('active-'+currentWord);

            lastUpdate = timestamp;
          }

          lastFrame = currentFrame;
          requestAnimationFrame(loopAni)

        }
        loopAni();

        // Mouse move events
        var $window_el = angular.element($window);
        var win_width = window.innerWidth;
        var win_height = window.innerHeight;

        $window_el.bind('mousemove',function(e){

          var x_cord = (win_width/2 - e.pageX);
          var y_cord = (win_height/2 - e.pageY);
          var x_per = x_cord / win_width;
          var y_per = y_cord / win_height;

          //trans_x = Math.round(x_per * 100 * (0+1));
          //trans_y = Math.round(y_per * 100 * (0+1));
          trans_x = win_width - e.pageX;
          trans_y = win_height - e.pageY;

          console.log(win_width, e.pageX, win_height, e.pageY);

        })



      }
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .controller('ResponderController', ResponderController);

  /** @ngInject */
  function ResponderController($scope, $http, $ratchet) {

    $scope.convos = [];
    $scope.convo =[];
    $scope.selectedConvo = {};
    $scope.messageModel = {};
    $scope.log = [];

    $http.get('http://chrisboustead_com.local.dev/convos')
      .then(function(res){

        $scope.convos = res.data;

        console.log($scope.convos);

      });


    $scope.selectConvo = function(key){

      $http.get('http://chrisboustead_com.local.dev/convo/'+key)
        .then(function(res){

          $scope.convo = res.data;

        });

    };





    $ratchet.onopen = function(){
      console.log('open');
    };

    $ratchet.onmessage = function(event){
      console.log('message',event.data);
    };


    $scope.sendMessage = function(message){

      // Record in the log...
      $scope.log.push({
        time : Date.now(),
        msg : message,
        from : 'Chris',
        convo_id : $scope.convo.key
      });

      // Send the message...
      $ratchet.send(JSON.stringify({
        from: 'admin',
        msg: message,
        convo_id : $scope.convo.key
      }));

      // Clear the input...
      $scope.messageModel.content = '';

    };

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $timeout, $http, $lightbox, $state, $location, $rootScope) {

    var pages = [
      'landing',
      'about',
      'contact'
    ];

    var isTouchDevice = function() {
      return 'ontouchstart' in window
        || navigator.maxTouchPoints;
    };

    var getWindowHeight = function(){
      //console.log(window.innerHeight);
      return window.innerHeight;
    };

    var scrollToPage = function(page_ind){

      var state = 'main.'+pages[page_ind];
      if(state == 'main.landing') state = 'main';

      $state.go(state);

      return TweenMax.to(window,.35,{
        scrollTo: {y:page_ind * getWindowHeight()},
        ease: Power2.easeOut,
        onComplete : function(){
          window.scrollTo(0, page_ind * getWindowHeight());
        }
      });
    };

    var snapToPage = function(y_cord){
      return window.scrollTo(0,y_cord);
    };

    // Page snap...
    (function(){

      var window_el = angular.element(window);
      var page_count = pages.length;
      var scrollStopInterval;
      var scroll_ani;

      var doc = document.documentElement;
      //var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);

      var getScrollTop = function() {
        return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      };

      var snapToNearest = function(cur_y) {
        var closest_to_y = 999999;
        var closest_to;
        for(var i = 0; i < page_count; ++i){
          var page_y = i * getWindowHeight();
          if (Math.min(Math.abs(page_y - cur_y), closest_to_y) < closest_to_y) closest_to = i;
          closest_to_y = Math.min(Math.abs(page_y - cur_y), closest_to_y);
        }
        //scroll_ani = TweenMax.to(window,.35,{scrollTo: {y:closest_to * window_height}, ease: Power2.easeOut})
        scroll_ani = scrollToPage(closest_to)

      };

      if(!isTouchDevice())
        window_el.bind('scroll',function(e){
          clearInterval(scrollStopInterval);

          scrollStopInterval = setTimeout(function(){
            snapToNearest(getScrollTop())
          },220);

        })


    }());


    // Init scroll
    var initScroll = function() {
      var path = $location.path();
      //console.log(path)
      if (path !== '/') {
        var path_clean = path.replace('/', '');
        var page_ind = _.indexOf(pages, path_clean);
        snapToPage(page_ind * getWindowHeight());
        //scrollToPage(page_ind * getWindowHeight(), page_ind);
      } else {
        snapToPage(0);
      }
    };

    //$timeout(initScroll, 200);
    //initScroll();


    $timeout(setupAnimation, 0, false);

    function setupAnimation() {


      var controller = new ScrollMagic.Controller();
      var landingPage = document.querySelector('#landingPage');
      var aboutPage = document.querySelector('#aboutPage');
      var aboutLogo = document.querySelector('#aboutPage .lockup');
      var aboutBgLogo = document.querySelector('#aboutPage .bg-logo');
      var landingBg = document.querySelector('.bg-landing');
      var bgWords = document.querySelectorAll('.bg-words .word');
      var logo = document.querySelector('.logo');
      var btnCont = document.querySelector('.btn-cont');
      var contactHeaderBg = document.querySelector('#contactPage header .bg');


      // Landing Page trans out
      var landingTransOut = new TimelineLite()
        .add([
          TweenMax.to(logo, .5, {y: -100, rotation: '360deg', opacity: 0, ease: Power3.easeIn}),
          TweenMax.to(btnCont, .5, {y: 100, opacity: 0, ease: Power3.easeIn})
        ], 0)
        .add([
          TweenMax.to(bgWords[0], .5, {x: -150, opacity: 0, ease: Power3.easeIn}),
          TweenMax.to(bgWords[1], .5, {x: 150, opacity: 0, ease: Power3.easeIn}),
          TweenMax.to(bgWords[2], .5, {x: -150, opacity: 0, ease: Power3.easeIn})
        ], .1);

      var landingBgTransOut = new TimelineLite()
        .add([
          TweenMax.to(landingBg, .5, {x: -600, opacity: 0, ease: Power3.easeIn})
        ], 0);


      // About page trans in ..
      var aboutTransIn = new TimelineLite()
        .from(aboutPage,.01,{zIndex: -1})
        .add([
          TweenMax.from(aboutPage, 1, {x: 200, opacity: 0, ease: Power3.easeOut}),
          TweenMax.from(aboutLogo, 1, {rotation: '-180deg', opacity: 0, ease: Power3.easeOut}),
          TweenMax.from(aboutBgLogo, 1, {rotation: '-180deg', opacity: 0, ease: Power3.easeOut})
        ]);

      // Contact page trans in ..
      var contactTransIn = new TimelineLite()
        .to(document.querySelector('body'), 1, {backgroundColor: '#242424', ease: Linear.easeNone});

      // Pin the site content
      //var landing_duration = landingPage.offsetHeight;
      var landing_duration = getWindowHeight();
      new ScrollMagic.Scene({triggerElement: ".pinned-pages", triggerHook: 0, duration: landing_duration })
        .setPin(".pinned-pages")
        //.addIndicators()
        .addTo(controller);

      // Transition out the landing page
      new ScrollMagic.Scene({triggerElement: ".pinned-pages", triggerHook: 0, duration: landing_duration /2})
        .setTween(landingTransOut)
        .addTo(controller);

      // Transition out the landing BG
      new ScrollMagic.Scene({triggerElement: ".pinned-pages", triggerHook: 0, duration: landing_duration/2, offset: landing_duration/3})
        .setTween(landingBgTransOut)
        //.addIndicators()
        .addTo(controller);

      // Tansition in the about page
      new ScrollMagic.Scene({offset: landing_duration/2, triggerHook: 0, duration: landing_duration/2})
        .setTween(aboutTransIn)
        //.addIndicators()
        .addTo(controller);

      // Tansition in the contact page
      new ScrollMagic.Scene({triggerElement: "#contactPage", triggerHook: 1, duration: landing_duration/2})
        .setTween(contactTransIn)
        .addTo(controller);

      initScroll();

    }



    $scope.showContent = function(page){

      if(window.ga) ga('send', 'pageview', '/'+page);

      var page_ind = _.findIndex(pages,function(val){
        return val == page;
      });

      scrollToPage(page_ind);

    };


    $scope.contactModel = {};
    $scope.contactSubmitted = false;
    $scope.contactError = false;
    $scope.contactFormLoading = false;

    $scope.contactSubmit = function($form){

      if(!$form.$valid)
        return;

      $scope.contactFormLoading = true;

      $http.post('send',$scope.contactModel)
        .then(function(res){
          $scope.contactSubmitted = true;
          $scope.contactFormLoading = false;
        })
        .catch(function(){
          $scope.contactError = true;
          $scope.contactFormLoading = false;
        })

    }

    $scope.showLightbox = $lightbox.show;

  }


})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $document, $rootScope) {

    $rootScope.mainLoaded = false;

    // ScrollMagic IE fix
    if(navigator.userAgent.match(/Trident\/7\./)) { // if IE
      angular.element($document[0].body).bind("mousewheel", function (event) {
        // remove default behavior
        event.preventDefault();

        //scroll without smoothing
        var wheelDelta = event.wheelDelta;
        var currentScrollPosition = window.pageYOffset;
        window.scrollTo(0, currentScrollPosition - wheelDelta);
      });
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {

    var scrollSettings = {
      templateUrl: 'app/main/main.html',
      controller: 'MainController',
      controllerAs: 'main'
    }

    $stateProvider
      .state('main', _.extend({
        url: '/'
      },scrollSettings))
      .state('main.about', _.extend({
        url: 'about'
      },scrollSettings))
      .state('main.contact', _.extend({
        url: 'contact'
      },scrollSettings))
      //.state('responder/convos', {
      //  url: '/responder/convos',
      //  templateUrl: 'app/responder/responder.html',
      //  controller: 'ResponderController',
      //  controllerAs: 'responder'
      //})
      //.state('responder/convo', {
      //  url: '/responder/convo/:id',
      //  templateUrl: 'app/responder/responder.html',
      //  controller: 'ResponderController',
      //  controllerAs: 'responder'
      //});


    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('chrisbousteadCom');

})();

(function() {
  'use strict';

  angular
    .module('chrisbousteadCom')
    .config(config);

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

  }

})();

angular.module("chrisbousteadCom").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"site-bgs\" nice-load=\"assets/images/main_bg.png\"><div class=\"vert-cont\"><div class=\"vert-center\"><div class=\"bg-words\"><div class=\"word dev\">Developer</div><div class=\"word eng\">Engineer</div><div class=\"word create\">Creative Thinker</div></div></div></div><div class=\"site-bg bg-landing\"></div></div><div id=\"mainPages\"><div class=\"pinned-pages\"><div class=\"main-page\" id=\"landingPage\"><div window-height=\"\"><div class=\"vert-cont\"><div class=\"vert-center\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"logo\"></div><div class=\"lockup-spacer\" match-height=\".bg-words\"></div><div class=\"btn-cont\"><button class=\"btn\" ng-click=\"showContent(\'about\')\">About</button> <button class=\"btn\" ng-click=\"showContent(\'contact\')\">Contact</button></div></div></div></div></div></div></div></div><div class=\"main-page\" id=\"aboutPage\" window-height=\"\"><div class=\"about-image-bg\" ng-style=\"aboutBg\" ng-show=\"aboutBgActive\"></div><div class=\"bg-logo visible-xs\"></div><div class=\"vert-cont\"><div class=\"vert-center\"><h2 class=\"title\">About Me</h2><div class=\"container\"><div class=\"row\"><div class=\"hidden-xs col-sm-3 col-md-offset-2 col-md-2\"><div><img src=\"assets/images/logo_lg.png\" class=\"lockup\" alt=\"\"></div><div class=\"portfolio-btn-cont\"><a href=\"http://resume.chrisboustead.com/\" class=\"btn\">My Portfolio</a></div></div><div class=\"col-sm-9 col-md-6\"><p>Hi! I\'m Chris Boustead.</p><p>Professionally, I\'m a freelance website and app developer/consultant. I hold a bachelors degree in <a about-photo=\"assets/images/about/degree.jpg\">Mechanical Engineering</a> and am a self-taught developer with 8 years professional experience in enterprise and agency roles.</p><p>I\'m a &ldquo;full-stack&rdquo; developer who works across a broad range of technologies, but who doesn\'t these days. My clients&rsquo; success is my success and I take extraordinary pride in my complete dedication to the success of my clients projects and goals.</p><p>Some of the brands I\'ve done work for include: <a about-photo=\"assets/images/about/cocacola.jpg\">Coca Cola</a>, <a about-photo=\"assets/images/about/absolut.jpg\">Absolut Vodka</a>, Jameson Irish Whiskey, <a about-photo=\"assets/images/about/campbells.jpg\">Campbell\'s</a>, Malibu Rum, <a about-photo=\"assets/images/about/shoprite.jpg\">ShopRite</a> and more.</p><p>In my free time I like to ride my <a about-photo=\"assets/images/about/bike.jpg\">little kid bike</a>, play in the <a about-photo=\"assets/images/about/dirt.jpg\">dirt</a> and <a about-photo=\"assets/images/about/snow.jpg\">snow</a>, and enjoy life. I\'ve never seen Game of Thrones or your other favorite TV series but I know we can find something else to talk about.</p><div class=\"portfolio-btn-cont visible-xs\"><a href=\"http://resume.chrisboustead.com/\" target=\"_blank\" class=\"btn\">My Portfolio</a></div></div></div></div></div></div></div></div><div class=\"main-page\" id=\"contactPage\" window-height=\"\"><div class=\"vert-cont\"><div class=\"vert-center\"><header><div class=\"bg\"></div><h2 class=\"title\">Contact Me</h2></header><div class=\"container\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-2 text-center\"><h4>I know your time is important.</h4><p>If you cannot reach me right away I will get get back to you in less than 24 hours.</p></div></div><div class=\"row\"><div class=\"col-md-offset-2 col-md-3\"><ul class=\"fa-ul\"><li><i class=\"fa fa-li fa-envelope\"></i> <a href=\"mailto:cbous1@gmail.com\">cbous1@gmail.com</a></li><li><i class=\"fa fa-li fa-map\"></i> Chris Boustead<br>554 Boston Post Rd. A4<br>Milford, CT 06460</li><li><i class=\"fa fa-li fa-phone\"></i> <a href=\"tel:2033092693\">(203) 309-2693</a></li></ul></div><div class=\"col-md-5\"><form name=\"contactForm\" class=\"contact-form\" novalidate=\"\" ng-submit=\"contactSubmit(contactForm)\" ng-show=\"!contactSubmitted\"><label for=\"contactName\">Your name:</label> <input type=\"text\" id=\"contactName\" name=\"name\" ng-model=\"contactModel.name\" placeholder=\"Name\" required=\"\"> <label for=\"contactEmail\">Your email:</label> <input type=\"email\" id=\"contactEmail\" name=\"email\" ng-model=\"contactModel.email\" placeholder=\"Email\" required=\"\"> <label for=\"contactComments\">Questions/Comments:</label> <textarea id=\"contactComments\" name=\"comments\" ng-model=\"contactModel.comments\" placeholder=\"Questions/Comments\" required=\"\"></textarea><div class=\"text-center\"><button type=\"submit\" class=\"btn\">Submit</button></div><div class=\"loader\" ng-show=\"contactFormLoading\"></div></form><div ng-show=\"contactSubmitted\" class=\"text-center\"><p>Thanks for your note! I\'ll be in touch within 24 hours.</p></div></div></div></div></div></div></div></div><lightbox class=\"lightbox\" ng-if=\"lightboxVisible\"></lightbox>");
$templateCache.put("app/responder/responder.html","<div class=\"container\"><div class=\"row\" ng-if=\"!convo.length\"><div class=\"col-sm-8 col-sm-offset-2\"><h3><strong>Choose a conversation:</strong></h3><select name=\"convo\" ng-model=\"selectedConvo.key\" class=\"form-control\" ng-change=\"selectConvo(selectedConvo.key)\"><option ng-repeat=\"conv in convos | orderBy:\'time\':true\" value=\"{{conv.key}}\">{{conv.time*1000 | date:\"short\"}} - {{conv.key}}</option></select></div></div><div class=\"row\" ng-if=\"convo.length\"><div class=\"col-sm-8 col-sm-offset-2\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Convo with: {{convo[0].from}}</h3></div><div class=\"panel-body\"><p ng-repeat=\"convo_item in convo\"><strong>{{convo_item.from}}:</strong> {{convo_item.text}}<br><time>{{convo_item.time*1000 | date:\"short\"}}</time></p></div></div></div></div></div>");
$templateCache.put("app/components/lightbox/lightbox.html","<div class=\"lightbox-cont\"><div class=\"lightbox-bg\"></div><button class=\"close\" ng-click=\"hide()\">close</button><div class=\"lightbox-content\"><div class=\"vert-cont\"><div class=\"vert-center\"><img ng-src=\"{{content}}\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/components/instant-convo/instant-convo.html","<div class=\"instant-convo\"><div class=\"instant-convo-window\"><p class=\"logitem\" ng-repeat=\"logitem in log\"><time>{{logitem.time | date:\"h:mm:ss\" }}</time><strong>{{logitem.from}}:</strong> {{logitem.msg}}</p></div><div class=\"instant-convo-input clearfix\"><input type=\"text\" ng-model=\"messageModel.content\" name=\"content\" placeholder=\"Type a message...\"> <span><button class=\"btn\" ng-click=\"sendMessage(messageModel.content)\">Send</button></span></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=\"layout-transparent mdl-layout mdl-js-layout\"><header class=\"site-header mdl-layout__header mdl-layout__header\"><div class=\"mdl-layout__header-row\"><span class=\"mdl-layout-title\">Chris Boustead</span><div class=\"mdl-layout-spacer\"></div><nav class=\"mdl-navigation\"><a class=\"mdl-navigation__link\" href=\"\">About</a> <a class=\"mdl-navigation__link\" href=\"\">Resume</a> <a class=\"mdl-navigation__link\" href=\"\">Portfolio</a> <a class=\"mdl-navigation__link\" href=\"\">Contact</a></nav></div></header><div class=\"mdl-layout__drawer\"><span class=\"mdl-layout-title\">Chris Boustead</span><nav class=\"mdl-navigation\"><a class=\"mdl-navigation__link\" href=\"\">About</a> <a class=\"mdl-navigation__link\" href=\"\">Resume</a> <a class=\"mdl-navigation__link\" href=\"\">Portfolio</a> <a class=\"mdl-navigation__link\" href=\"\">Contact</a></nav></div></div>");
$templateCache.put("app/components/page-loader/page-loader.html","<div class=\"page-loader\" ng-if=\"loaderVisible\"><div class=\"loader\"></div></div>");}]);